import { createFileRoute, useParams } from "@tanstack/react-router";
import { SalesOrderDetailPage } from "@/components/inventory/SalesOrderDetailPage";

export const Route = createFileRoute("/admin/_layout/inventory/sales-orders_/$id")({
  component: AdminSODetail,
});

function AdminSODetail() {
  const { id } = useParams({ from: "/admin/_layout/inventory/sales-orders_/$id" });
  return <SalesOrderDetailPage soId={id} />;
}
